import styled from 'styled-components';
import Link from 'next/link';

import { useTranslation } from '@hooks';
import { TickIcon } from '@components/icons';
import { Caption2 } from '@components/styles/Typography';

const ColorVariants = ({
    variantColors,
    onProductChange,
    selectedVariant,
    slug,
}) => {
    const { t } = useTranslation();
    return (
        <ColorVariantsWrapper>
            {variantColors?.length > 0 &&
                variantColors?.slice(0, 3).map((variantColor) => (
                    <ColorVariantItem
                        key={variantColor.id}
                        role="button"
                        aria-label="variant-color"
                        backgroundImage={variantColor?.image_colour}
                        isWhite={
                            variantColor.hex_code === '#f5f5f5' ||
                            variantColor.hex_code === '#ffffff'
                        }
                        isSelected={selectedVariant === variantColor.id}
                        onClick={() => onProductChange(variantColor.id)}
                    >
                        {selectedVariant === variantColor.id && <TickIcon />}
                    </ColorVariantItem>
                ))}
            {variantColors?.length > 3 && (
                <Link
                    href={`/${t('productSlug')}/${slug}`}
                    passHref
                    aria-label="other-variants"
                >
                    <ColorVariantCount>
                        +{variantColors.length - 3}
                    </ColorVariantCount>
                </Link>
            )}
        </ColorVariantsWrapper>
    );
};
const ColorVariantsWrapper = styled.div`
    display: flex;
    align-self: flex-end;
`;
const ColorVariantItem = styled.div`
    background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
    background-repeat: no-repeat;
    background-position: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    margin-right: 7px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
        width: 8px;

        path {
            fill: ${({ isWhite, theme }) => isWhite && theme.colors.primary};
        }
    }

    :last-child {
        margin-right: 0;
    }

    ::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        border-radius: 50%;
        box-shadow: 0 0 0 0.6px rgba(0, 0, 0, 0.07);
        z-index: -1;
    }
`;
const ColorVariantCount = styled(Caption2)`
    position: relative;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default ColorVariants;
